import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";

import { useModal } from "@root/client/modal";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveStrategicAxes,
} from "@planzone/view-models";
import { StrategicAxes } from "./strategicAxes";
import { Props } from "./types";
import styles from "./styles.scss";

function StrategicAxesPage(props: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { strategicAxes, retrieveStrategicAxes } = useRetrieveStrategicAxes();
  const { pushView } = useModal();

  React.useEffect(() => {
    retrieveStrategicAxes(planzone);
  }, []);

  return (
    <div className={styles.strategicAxesPage}>
      <div className={styles.main}>
        <div className={styles.menu}>
          <button
            className={styles.button}
            onClick={() =>
              pushView({
                key: UseCases.createStrategicAxis,
                data: undefined,
              })
            }
          >
            <div className={styles.iconBox}>+</div>
            <p>{t("strategicAxesPage.createStrategicAxis")}</p>
          </button>
        </div>
        <div className={styles.container}>
          <StrategicAxes strategicAxes={strategicAxes} />
        </div>
      </div>
    </div>
  );
}

export { StrategicAxesPage };
